<template>
  <div class="dashboard-box">
    <h2>Company info:</h2>
    <div class="row">
      <div class="col-lg-6">
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Company</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Name"
              :value="startup.name"
              attr="name"
              @input="onInputChangedForField('name', $event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Country</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <p class="dashboard-value">
              <CountryDropdown class="seamless overview" />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">City</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="City"
              :value="startup.city"
              attr="city"
              @input="onInputChangedForField('city', $event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Website</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Website URL"
              :value="startup.website"
              attr="website"
              @input="onInputChangedForField('website', $event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Facebook</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Facebook URL"
              :value="startup.facebook"
              attr="facebook"
              @input="onInputChangedForField('facebook', $event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Twitter</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Twitter URL"
              :value="startup.twitter"
              attr="twitter"
              @input="onInputChangedForField('twitter', $event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Linkedin</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Linkedin URL"
              :value="startup.linkedin"
              attr="linkedin"
              @input="onInputChangedForField('linkedin', $event)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Founded</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <p class="dashboard-value">
              <el-popover placement="top" title="Tip">
                <YearMonthPicker
                  slot="reference"
                  class="form-control overview-input"
                  placeholder="Year and month"
                  :value="founded_at"
                  @blur="setFoundedAt"
                  @month-selected="setFoundedAt"
                />
                <div v-html="helpMessages.founded"></div>
              </el-popover>
            </p>
            <p v-if="(apiErrors.founded_at || []).length" class="text-danger">
              Must have "MMM YYYY" format (ie: "Jan 2016")
            </p>
          </div>
        </div>
      </div>
      <!-- end of left column -->

      <!-- begin of right column -->
      <div class="col-lg-6">
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Business Type</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <p class="dashboard-value">
              <BusinessTypeDropdown class="seamless overview" />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Team Members</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Team Members Number"
              :value="startup.employees_count"
              attr="employees_count"
              @input="onInputChangedForField('employees_count', $event)"
            />
            <p
              v-for="error in apiErrors.employees_count || []"
              :key="error"
              class="text-danger"
            >
              {{ error }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Product Type</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <p class="dashboard-value">
              <ProductTypeDropdown class="seamless overview" />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">Company stage</p>
          </div>
          <div class="col-md-9 col-lg-7">
            <p class="dashboard-value">
              <StageDropdown class="seamless overview" />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">
              <HelpTip
                title=""
                class="inline-block"
                message="Annual Revenue in €, eg. 100000"
                label="AR (€)"
              />
            </p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Revenue (EUR)"
              :value="startup.annual_revenue"
              attr="revenue"
              @blur="onInputChangedForField('annual_revenue', $event)"
            />
            <p
              v-for="error in apiErrors.annual_revenue || []"
              :key="error"
              class="text-danger"
            >
              {{ error }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">
              <HelpTip
                title=""
                class="inline-block"
                :message="helpMessages.mrr"
                label="MRR (€)"
              />
            </p>
          </div>
          <div class="col-md-9 col-lg-7">
            <input
              class="form-control overview-input"
              placeholder="Revenue (EUR)"
              :value="startup.monthly_recurring_revenue"
              attr="revenue"
              @blur="
                onInputChangedForField('monthly_recurring_revenue', $event)
              "
            />
            <p
              v-for="error in apiErrors.monthly_recurring_revenue || []"
              :key="error"
              class="text-danger"
            >
              {{ error }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-5">
            <p class="dashboard-label">
              <HelpTip title="" :message="helpMessages.ir" label="IP" />
            </p>
          </div>
          <div class="col-md-9 col-lg-7">
            <p class="dashboard-value">
              <IntellectualPropertyDropdown class="seamless overview" />
            </p>
          </div>
        </div>
      </div>
      <!-- end of right column -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import CountryDropdown from './CountryDropdown.vue'
import BusinessTypeDropdown from './BusinessTypeDropdown.vue'
import ProductTypeDropdown from './ProductTypeDropdown.vue'
import IntellectualPropertyDropdown from './IntellectualPropertyDropdown.vue'
import StageDropdown from './StageDropdown.vue'
import HelpTip from 'components/common/HelpTip.vue'
import { dateFilter, moneyToNumber } from '@/filters'
import helpMessages from './helpMessages'

export default {
  components: {
    CountryDropdown,
    BusinessTypeDropdown,
    ProductTypeDropdown,
    StageDropdown,
    IntellectualPropertyDropdown,
    HelpTip,
  },
  data() {
    return {
      helpMessages,
    }
  },
  computed: {
    founded_at() {
      if (this.startup.founded_at) {
        return dateFilter(this.startup.founded_at, 'MMM Y')
      }

      return ''
    },
    ...mapState({
      startup: (state) => state.startupProfile.startup,
      apiErrors: (state) => state.startupProfile.errors,
    }),
    ...mapGetters({
      websiteLink: 'startupProfile/websiteLink',
      facebookLink: 'startupProfile/facebookLink',
      twitterLink: 'startupProfile/twitterLink',
      linkedinLink: 'startupProfile/linkedinLink',
    }),
  },
  methods: {
    setFoundedAt(value) {
      const attr = 'founded_at'

      if (value) {
        value = moment(value, 'MMM Y') // parse value that we get from YearMonthPicker
        value = dateFilter(value) // format with a day to be accepted by the backend
        this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
      } else {
        this.$store.commit('startupProfile/SET_STARTUP_ATTR', {
          attr,
          value: null,
        })
      }
    },
    onInputChangedForField(attr, $event) {
      let value = $event.target.value
      if (this.startup[attr] !== value) {
        this.$store.dispatch('startupProfile/setAttr', { attr, value })
      }
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/vars.scss';
@import '~assets/css/colors.scss';

.dropdown-value:after {
  content: '';
  display: block;
  margin: auto;
  height: 2px;
  width: 0px;
  background: transparent;
  transition: width 0.3s ease, background-color 0.3s ease;
}
.dropdown-value:focus:after {
  width: 100%;
  background: $brand-primary;
}

.form-control.overview-input,
.overview-input {
  outline: none;
  border-width: 0 0 1px 0;
  border-color: $grey160;
  padding: 0px;

  &:hover,
  &:focus {
    color: $grey30;
  }
  // the duplicated styles are for datepicker component
  input {
    outline: none;
    border-width: 0 0 1px 0;
    padding: 6px 0px;

    &:hover,
    &:focus {
      color: $grey30;
    }
  }

  &::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: $grey120;
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: $grey120;
    opacity: 1;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: $grey120;
    opacity: 1;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: $grey120;
  }
  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: $grey120;
  }
}
</style>
